import { IDefaultAvatarProps } from './DefaultAvatar.types';

const DefaultAvatar = ({ title }: IDefaultAvatarProps): JSX.Element => {
  return (
    <svg
      fill="#9c9c9c"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path d="M166 196c0 49.626 40.374 90 90 90s90-40.374 90-90-40.374-90-90-90-90 40.374-90 90zm160 0c0 38.598-31.402 70-70 70s-70-31.402-70-70 31.402-70 70-70 70 31.402 70 70z" />
      <circle cx="440" cy="92" r="10" />
      <path d="M256 512c141.904 0 256-114.927 256-256 0-46.969-12.806-92.884-37.031-132.782-2.866-4.72-9.015-6.223-13.738-3.358-4.721 2.867-6.224 9.017-3.357 13.738C480.199 170.367 492 212.693 492 256c0 68.428-28.771 131.896-79.476 176.683C397.088 359.874 332.528 306 256 306S114.905 359.88 99.485 432.692C48.774 387.9 20 324.429 20 256 20 125.869 125.869 20 256 20c52.989 0 103.031 17.115 144.716 49.496 4.361 3.388 10.644 2.598 14.032-1.763s2.599-10.644-1.763-14.032C367.759 18.569 313.474 0 256 0 187.564 0 123.262 26.616 74.937 74.944 26.613 123.27 0 187.57 0 256c0 141.429 114.459 256 256 256zm0-186c70.697 0 129.381 51.64 138.722 121.007C354.267 476.46 306.429 492 256 492c-50.424 0-98.256-15.542-138.711-44.996C126.617 377.638 185.295 326 256 326z" />
    </svg>
  );
};

export default DefaultAvatar;
